"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ColorsPreview = void 0;
var tslib_1 = require("tslib");
// (C) 2007-2022 GoodData Corporation
var react_1 = tslib_1.__importStar(require("react"));
var utils_1 = require("../utils");
var ColorsPreview = /** @class */ (function (_super) {
    tslib_1.__extends(ColorsPreview, _super);
    function ColorsPreview() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ColorsPreview.prototype.render = function () {
        return (react_1.default.createElement("div", { className: "color-picker-preview" },
            react_1.default.createElement(ColorItem, { id: "current-color", hslColor: this.props.currentHslColor, textLabel: this.props.currentTextLabel }),
            react_1.default.createElement(ColorItem, { id: "new-color", hslColor: this.props.draftHslColor, textLabel: this.props.draftTextLabel })));
    };
    ColorsPreview.defaultProps = {
        currentTextLabel: "current",
        draftTextLabel: "new",
    };
    return ColorsPreview;
}(react_1.PureComponent));
exports.ColorsPreview = ColorsPreview;
var ColorItem = /** @class */ (function (_super) {
    tslib_1.__extends(ColorItem, _super);
    function ColorItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ColorItem.prototype.render = function () {
        return (react_1.default.createElement("div", { className: "color-picker-value-wrapper" },
            react_1.default.createElement("div", { "aria-label": this.props.id, className: "color-value s-" + this.props.id, style: utils_1.getColorStyle(this.props.hslColor) }),
            react_1.default.createElement("span", null, this.props.textLabel)));
    };
    return ColorItem;
}(react_1.PureComponent));
//# sourceMappingURL=ColorsPreview.js.map